import { useSelector } from "react-redux";
import { handleValidateCodevalue } from "../Utility/constant";
import CommonEmail from "./CommonEmail";
import { StyledGridContainer, StyledSubHeader } from "./Styled";
import TextFiledWithLabel from "./TextFieldWithLabel";
import PhoneNumberField from "./PhoneNumberField";

const CommonPoc = ({required = false ,isDetailPage,isViewMode,requiredValue, handleOnChange , state} ) => {

  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)

  return (
    <>
    <StyledSubHeader>
    {handleValidateCodevalue(internationalise,'COMMON_POC_DETAILS')} 
    </StyledSubHeader>
    <StyledGridContainer>
    <TextFiledWithLabel
    required={required}
    name= "pocFirstName"
    isViewMode = {isViewMode}
    value= {state?.pocFirstName}
    error={state?.pocFirstName ? false : requiredValue?.pocFirstName}
    label={handleValidateCodevalue(internationalise,'COMMON_POC_FIRSTNAME')}
    handleOnChange={handleOnChange}
    helperText= ""
    />
    
    <TextFiledWithLabel
    required={required}
    name= "pocLastName"
    isViewMode = {isViewMode}
    value= {state?.pocLastName}
    error={state?.pocLastName ? false : requiredValue?.pocLastName}
    label={handleValidateCodevalue(internationalise,'COMMON_POC_LASTNAME')}
    handleOnChange={handleOnChange}
    helperText= ""
    />
 <PhoneNumberField
  required={required}
  isDetailPage={isDetailPage}
  isViewMode={isViewMode}
  name="pocPhone"
  countryCodeName="pocPhoneCountryCode"
  countryCode={state?.pocPhoneCountryCode || "+91"}
  isRequired={requiredValue?.pocPhone}
  value={state?.pocPhone}
  handleOnChange={handleOnChange}
/>
    <CommonEmail
    required={required}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode}
    requiredValue = {requiredValue?.pocEmail}
    name = 'pocEmail'
    value = {state?.pocEmail}
    isRequired = {requiredValue?.pocEmail}
    handleOnChange={handleOnChange}
    />
</StyledGridContainer>
</>)
}

export default CommonPoc

